var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DeskPool } from '../../DeskPool';
import { startIntroductionPhase } from '../../../../api';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { Roles } from '../../../molecules/Roles/Roles';
export function SetRoles() {
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const getAddOnComponent = ({ player, onClose, players }) => (_jsx(Roles, { player: player, players: players, onClose: onClose }));
    const onStartGameClick = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield startIntroductionPhase((matchState === null || matchState === void 0 ? void 0 : matchState.id) || '');
            // console.log('MatchDesk onStartGameClick', result)
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
            console.error('MatchDesk onStartGameClick error', err.response);
        }
    });
    const gameButtonState = {
        text: 'Начать игру',
        visible: true,
        onClick: onStartGameClick,
    };
    return _jsx(DeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState, addOnComponent: getAddOnComponent });
}
